export const emitAdminToast = (message, type = 'info') => {
  if (typeof window === 'undefined' || !message) return;
  window.dispatchEvent(new CustomEvent('admin:toast', { detail: { message, type } }));
};
